import { useLazyLoadQuery } from "react-relay"
import { graphql } from "relay-runtime"
import { useReferredByReasonsQuery } from "@/modules/patients/services/ch/__generated__/useReferredByReasonsQuery.graphql"

export const referredByReasonsQuery = graphql`
  query useReferredByReasonsQuery {
    ch_referredByReasons {
      key
      value
    }
  }
`
export const useSwissReferredByReasonsQuery = () => {
  return useLazyLoadQuery<useReferredByReasonsQuery>(referredByReasonsQuery, {})
}
